import React, { Component } from 'react'
import { connect } from 'react-redux'
import withTranslationWrapper from '../../HOC/HocTranslate'
import { notifyError } from '../../Utils/CustomNotifcations'
import Layout from './../../wrapper'
import { logInUserInfo } from '../../Actions/Users'
import { UsersList } from '../../Components/Users/usersModalforSuperAdmin'
import { checkPrivileges } from '../../Helpers'
import withRoutes from '../../HOC/HocRoutes'
import { apiFetch } from '../../Utils/apiFetch'

class Users extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isVisable: true,
      sessionCallTrack: true
    }
  }
  componentWillMount () {
        // this.props.dispatch(Notifications.removeAll())
    //   if (
    //     localStorage.getItem('adminToken')
    //   ) {
    //     window.location.replace('/login')
    //   }
  }

  controleSession = () => {
    if (localStorage.getItem('userInfo')) {
      apiFetch('/api/session', {
        method: 'DELETE'
      }).then(res => {
        let response = res.data
        if (response.ok) {
          this.props.navigate('/logout')
        }else{
          throw response
        }
      }).catch(e => {})
    }
  }

  render () {
    if (checkPrivileges('user')) {
      if (this.props.logInUser) {
        return (
          <Layout {...this.props}>
            <UsersList history={this.props.history} />
          </Layout>
        )
      } else {
        if (this.state.sessionCallTrack) {
          this.setState(
            {
              sessionCallTrack: false
            },
            () => {
              apiFetch('/api/session?app=2bd5bd10345cd1555b14c221ec6e8647c46ee21e8ee45312', {
                headers: { Accept: 'application/json; odata=verbose' }
              }).then(response => {
                if (response.ok) {
                  response.json().then(res => {
                    if(res.status ==='success'){ 
                      let userInfo = res.data
                      this.props.setActiveLanguage(
                        userInfo?.attributes?.lang || 'en'
                      )
                      // apiFetch call for Api  privileges
                      if(userInfo?.roleId){
                        apiFetch(`/api/roles/privileges?roleId=${userInfo.roleId}`, {
                          method: 'Get'
                        })
                          .then(response => {
                            if (response.ok) {
                              response.json().then(res1 => {
                                if(res1.status ==='success'){ 
                                  let privileges = res1.data
                                  let privilegeKeys = []
                                  privileges.map(item => {
                                    privilegeKeys.push(item.privilegeKey)
                                  })
                                  localStorage.setItem(
                                    'privileges',
                                    JSON.stringify({ ...privilegeKeys })
                                  )
                                  if (privileges.length) {
                                    localStorage.setItem('userToken', '')
                                    this.props.navigate('/users')
                                  } else {
                                    this.setState({
                                      loading: false,
                                      loginErrorMessage: 'lackOfPrivileges'
                                    })
                                  }
                                }
                                else if(res?.statusCode === '440'){
                                  window.location.replace('/login')
                                }
                                else if(res.statusCode){
                                  var err = res?.message.split(':')
                                  err[1] =err[1].replace(')', "")
                                  this.props.dispatch(
                                    notifyError(this.props.translate(err[1]))
                                  )
                                }
                              })
                            } else {
                              throw response
                            }
                          })
                          .catch(e => {
                            console.log('e =',e)
                            // this.props.dispatch(notifyError({
                            //   message: 'somethingWentWrong',
                            //   autoDismiss: 5
                            // }))
                          })
                      }
  
                      this.props.dispatch(logInUserInfo(userInfo))

                    }
                    else if(res?.statusCode === '440'){
                      window.location.replace('/login')
                    }
                    else if(res.statusCode){
                      var err = res?.message.split(':')
                      err[1] =err[1].replace(')', "")
                      this.props.dispatch(
                        notifyError(this.props.translate(err[1]))
                      )
                      this.props.navigate('/logout')
                    }
                  })
                } else {
                  this.props.navigate('/logout')
                    throw response
                  }
                }).catch(e => {
                  this.props.dispatch(notifyError('somethingWentWrong'))
                })
            }
          )
        }
        return null
      }
    } else if (
      checkPrivileges('account') &&
      !checkPrivileges('device') &&
      !checkPrivileges('group')
    ) {
      this.controleSession()
      return null
    } else {
      return defaultPages.map(page => {
        if (checkPrivileges(page)) {
          if (page === 'device') {
            this.props.navigate(`/units`)
          } else {
            this.props.navigate(`/${page}s`)
          }
        }
      })
    }
  }
}

const mapStateToProps = state => ({
  ServerSetting: state.ServerSetting,
  logInUser: state.logInUsers
})

export default connect(mapStateToProps)(withRoutes(withTranslationWrapper(Users)))

const defaultPages = ['account', 'device', 'group']
